module.exports = __webpack_public_path__ + "static/img/7.19176cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/7.png
// module id = NgYH
// module chunks = 0